function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { TranslationsNamespaceProvider, TranslationsProvider } from '@ori/i18n';
import { defaultTranslations, translationsNamespace } from '../constants/defaultTranslations';
export var I18nContainer = function(props) {
    var currentLanguage = props.currentLanguage, staticApiUrl = props.staticApiUrl, tenant = props.tenant, children = props.children;
    var translationProps = {
        clientFetchConfiguration: {
            baseUrl: staticApiUrl,
            onError: function(error) {
                console.log('Error occured while loading translations.', String(error));
            },
            tenant: tenant
        },
        currentLanguage: currentLanguage,
        defaultTranslationsWithNamespaces: _define_property({}, translationsNamespace, defaultTranslations)
    };
    return /*#__PURE__*/ _jsx(TranslationsProvider, _object_spread_props(_object_spread({}, translationProps), {
        children: /*#__PURE__*/ _jsx(TranslationsNamespaceProvider, {
            namespace: translationsNamespace,
            children: children
        })
    }));
};
